// @flow
import React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import type {
  AvailableSettings,
  SettingType,
} from 'docs/data/integration-builder';
import {DefaultSettings, DEFAULT_SETTINGS} from './DefaultSettings';
import {ServerOnlySettings, SERVER_ONLY_SETTINGS} from './ServerOnlySettings';
import {WebOnlySettings, WEB_ONLY_SETTINGS} from './WebOnlySettings';
import {
  WebDynamicOnlySettings,
  WEB_DYNAMIC_ONLY_SETTINGS,
} from './WebDynamicOnlySettings';
import {TerminalSettings, TERMINAL_SETTINGS} from './TerminalSettings';
import {ReactOnlySettings, REACT_ONLY_SETTINGS} from './ReactOnlySettings';
import {
  WebWithNextSettings,
  WEB_WITH_NEXT_SETTINGS,
} from './WebWithNextSettings';
import {SettingsHandlerContext} from './SettingsHandler';

type SettingsProps = {|
  type: SettingType,
  onSettingChange: (prefs: {[string]: string}) => void,
|};

export const getAvailableSettings = (type: SettingType): AvailableSettings => {
  switch (type) {
    case 'web-only':
      return WEB_ONLY_SETTINGS;
    case 'server-only':
      return SERVER_ONLY_SETTINGS;
    case 'web-with-next':
      return WEB_WITH_NEXT_SETTINGS;
    case 'terminal':
      return TERMINAL_SETTINGS;
    case 'react-only':
      return REACT_ONLY_SETTINGS;
    case 'web-dynamic-only':
      return WEB_DYNAMIC_ONLY_SETTINGS;
    default:
      return DEFAULT_SETTINGS;
  }
};

export const Settings = ({type, onSettingChange}: SettingsProps) => {
  let SettingsComponent;
  switch (type) {
    case 'server-only':
      SettingsComponent = <ServerOnlySettings />;
      break;
    case 'web-only':
      SettingsComponent = <WebOnlySettings />;
      break;
    case 'react-only':
      SettingsComponent = <ReactOnlySettings />;
      break;
    case 'web-with-next':
      SettingsComponent = <WebWithNextSettings />;
      break;
    case 'terminal':
      SettingsComponent = <TerminalSettings />;
      break;
    case 'web-dynamic-only':
      SettingsComponent = <WebDynamicOnlySettings />;
      break;
    default:
      SettingsComponent = <DefaultSettings />;
      break;
  }

  return (
    <Box
      className={classNames('Settings', type)}
      flex={{justifyContent: 'space-between', alignItems: 'center'}}
    >
      <SettingsHandlerContext.Provider
        value={{
          onSettingChange,
        }}
      >
        {SettingsComponent}
      </SettingsHandlerContext.Provider>
    </Box>
  );
};
